import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

import { sortedDropdownItemLabels } from '../utils/utils';

import DA from '../store/ReduxAccess';

import CrmTextField from './CrmTextField';
import PhoneInput from './PhoneInput';
import KSelect from './KSelect';

const localStyles = (theme) => ({
  root: {
    marginTop: '12px',
  },
});

class NewOrgContactPanel extends React.Component {
  render() {
    const { classes, ownerModal, personLabel } = this.props;
    const nameFieldLabel = personLabel + ' Name';
    const possibleOwners = DA.getAllFirmUsers();
    const possibleTemperatures = sortedDropdownItemLabels('Referral Contact Temperature');

    return (
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <CrmTextField
              label={nameFieldLabel}
              id="contactName"
              fullWidth
              required
              value={ownerModal.state.contactName}
              onChange={(event) => ownerModal.handleTextChange(event)}
            />
          </Grid>
          <Grid item xs={12}>
            <CrmTextField
              label="Job Title"
              id="contactJobTitle"
              fullWidth
              required
              value={ownerModal.state.contactJobTitle}
              onChange={(event) => ownerModal.handleTextChange(event)}
            />
          </Grid>
          <Grid item xs={12}>
            <CrmTextField
              label="Description"
              id="contactDescription"
              fullWidth
              value={ownerModal.state.contactDescription}
              onChange={(event) => ownerModal.handleTextChange(event)}
            />
          </Grid>
          <Grid item xs={6}>
            <PhoneInput
              label="Phone 1"
              possibleRoles={ownerModal.possibleContactPhoneRoles}
              actualRoles={ownerModal.state.contactPhone1Roles}
              number={ownerModal.state.contactPhone1Number}
              onRolesChange={(rolesObj) => ownerModal.handleContactPhone1RolesChange(rolesObj)}
              onNumberChange={(newNumber) => ownerModal.handleContactPhone1NumberChange(newNumber)}
            />
          </Grid>
          <Grid item xs={6}>
            <PhoneInput
              label="Phone 2"
              possibleRoles={ownerModal.possibleContactPhoneRoles}
              actualRoles={ownerModal.state.contactPhone2Roles}
              number={ownerModal.state.contactPhone2Number}
              onRolesChange={(rolesObj) => ownerModal.handleContactPhone2RolesChange(rolesObj)}
              onNumberChange={(newNumber) => ownerModal.handleContactPhone2NumberChange(newNumber)}
            />
          </Grid>
          <Grid item xs={12}>
            <CrmTextField
              label="Email"
              id="contactEmail"
              fullWidth
              value={ownerModal.state.contactEmail}
              onChange={(event) => ownerModal.handleTextChange(event)}
            />
          </Grid>
          <Grid item xs={12}>
            <KSelect
              label="Owner"
              fullWidth={true}
              liveOptions={possibleOwners.map((c) => c.name)}
              liveValues={possibleOwners.map((c) => c.personId)}
              value={ownerModal.state.contactOwnerId}
              onChange={(event) => ownerModal.setState({ contactOwnerId: event.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <KSelect
              label="Temperature"
              fullWidth={true}
              liveOptions={possibleTemperatures}
              liveValues={possibleTemperatures}
              value={ownerModal.state.contactTemperature}
              onChange={(event) => ownerModal.setState({ contactTemperature: event.target.value })}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(localStyles)(NewOrgContactPanel);
